module.exports = __webpack_public_path__ + "img/zip.7994c1c5.png";